// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file blobstore/v1/blobs.proto (package blobstore.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file blobstore/v1/blobs.proto.
 */
export const file_blobstore_v1_blobs: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * BlobMetadata contains blob information without content.
 *
 * @generated from message blobstore.v1.BlobMetadata
 */
export type BlobMetadata = Message<"blobstore.v1.BlobMetadata"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: int64 size = 3;
   */
  size: bigint;

  /**
   * @generated from field: string hash = 4;
   */
  hash: string;

  /**
   * @generated from field: map<string, string> metadata = 5;
   */
  metadata: { [key: string]: string };

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message blobstore.v1.BlobMetadata.
 * Use `create(BlobMetadataSchema)` to create a new message.
 */
export const BlobMetadataSchema: GenMessage<BlobMetadata> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 0);

/**
 * UploadRequest streams blob content.
 *
 * @generated from message blobstore.v1.UploadRequest
 */
export type UploadRequest = Message<"blobstore.v1.UploadRequest"> & {
  /**
   * @generated from oneof blobstore.v1.UploadRequest.data
   */
  data: {
    /**
     * metadata is sent in the first message.
     *
     * @generated from field: blobstore.v1.UploadMetadata metadata = 1;
     */
    value: UploadMetadata;
    case: "metadata";
  } | {
    /**
     * chunk contains blob data.
     *
     * @generated from field: bytes chunk = 2;
     */
    value: Uint8Array;
    case: "chunk";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message blobstore.v1.UploadRequest.
 * Use `create(UploadRequestSchema)` to create a new message.
 */
export const UploadRequestSchema: GenMessage<UploadRequest> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 1);

/**
 * @generated from message blobstore.v1.UploadMetadata
 */
export type UploadMetadata = Message<"blobstore.v1.UploadMetadata"> & {
  /**
   * @generated from field: string content_type = 1;
   */
  contentType: string;

  /**
   * @generated from field: map<string, string> metadata = 2;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message blobstore.v1.UploadMetadata.
 * Use `create(UploadMetadataSchema)` to create a new message.
 */
export const UploadMetadataSchema: GenMessage<UploadMetadata> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 2);

/**
 * @generated from message blobstore.v1.UploadResponse
 */
export type UploadResponse = Message<"blobstore.v1.UploadResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 size = 2;
   */
  size: bigint;

  /**
   * @generated from field: string hash = 3;
   */
  hash: string;
};

/**
 * Describes the message blobstore.v1.UploadResponse.
 * Use `create(UploadResponseSchema)` to create a new message.
 */
export const UploadResponseSchema: GenMessage<UploadResponse> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 3);

/**
 * @generated from message blobstore.v1.DownloadRequest
 */
export type DownloadRequest = Message<"blobstore.v1.DownloadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message blobstore.v1.DownloadRequest.
 * Use `create(DownloadRequestSchema)` to create a new message.
 */
export const DownloadRequestSchema: GenMessage<DownloadRequest> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 4);

/**
 * DownloadResponse streams blob content.
 *
 * @generated from message blobstore.v1.DownloadResponse
 */
export type DownloadResponse = Message<"blobstore.v1.DownloadResponse"> & {
  /**
   * @generated from oneof blobstore.v1.DownloadResponse.data
   */
  data: {
    /**
     * metadata is sent in the first message.
     *
     * @generated from field: blobstore.v1.BlobMetadata metadata = 1;
     */
    value: BlobMetadata;
    case: "metadata";
  } | {
    /**
     * chunk contains blob data.
     *
     * @generated from field: bytes chunk = 2;
     */
    value: Uint8Array;
    case: "chunk";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message blobstore.v1.DownloadResponse.
 * Use `create(DownloadResponseSchema)` to create a new message.
 */
export const DownloadResponseSchema: GenMessage<DownloadResponse> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 5);

/**
 * @generated from message blobstore.v1.GetMetadataRequest
 */
export type GetMetadataRequest = Message<"blobstore.v1.GetMetadataRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message blobstore.v1.GetMetadataRequest.
 * Use `create(GetMetadataRequestSchema)` to create a new message.
 */
export const GetMetadataRequestSchema: GenMessage<GetMetadataRequest> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 6);

/**
 * @generated from message blobstore.v1.GetMetadataResponse
 */
export type GetMetadataResponse = Message<"blobstore.v1.GetMetadataResponse"> & {
  /**
   * @generated from field: blobstore.v1.BlobMetadata metadata = 1;
   */
  metadata?: BlobMetadata | undefined;
};

/**
 * Describes the message blobstore.v1.GetMetadataResponse.
 * Use `create(GetMetadataResponseSchema)` to create a new message.
 */
export const GetMetadataResponseSchema: GenMessage<GetMetadataResponse> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 7);

/**
 * @generated from message blobstore.v1.DeleteRequest
 */
export type DeleteRequest = Message<"blobstore.v1.DeleteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message blobstore.v1.DeleteRequest.
 * Use `create(DeleteRequestSchema)` to create a new message.
 */
export const DeleteRequestSchema: GenMessage<DeleteRequest> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 8);

/**
 * @generated from message blobstore.v1.DeleteResponse
 */
export type DeleteResponse = Message<"blobstore.v1.DeleteResponse"> & {
};

/**
 * Describes the message blobstore.v1.DeleteResponse.
 * Use `create(DeleteResponseSchema)` to create a new message.
 */
export const DeleteResponseSchema: GenMessage<DeleteResponse> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 9);

/**
 * @generated from message blobstore.v1.ListRequest
 */
export type ListRequest = Message<"blobstore.v1.ListRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message blobstore.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 10);

/**
 * @generated from message blobstore.v1.ListResponse
 */
export type ListResponse = Message<"blobstore.v1.ListResponse"> & {
  /**
   * @generated from field: repeated blobstore.v1.BlobMetadata blobs = 1;
   */
  blobs: BlobMetadata[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message blobstore.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 11);

/**
 * @generated from message blobstore.v1.SearchRequest
 */
export type SearchRequest = Message<"blobstore.v1.SearchRequest"> & {
  /**
   * metadata_filters matches blobs with these metadata key-values.
   *
   * @generated from field: map<string, string> metadata_filters = 1;
   */
  metadataFilters: { [key: string]: string };

  /**
   * content_type filters by content type.
   *
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * min_size filters by minimum size.
   *
   * @generated from field: int64 min_size = 3;
   */
  minSize: bigint;

  /**
   * max_size filters by maximum size.
   *
   * @generated from field: int64 max_size = 4;
   */
  maxSize: bigint;

  /**
   * created_after filters by creation time.
   *
   * @generated from field: google.protobuf.Timestamp created_after = 5;
   */
  createdAfter?: Timestamp | undefined;

  /**
   * created_before filters by creation time.
   *
   * @generated from field: google.protobuf.Timestamp created_before = 6;
   */
  createdBefore?: Timestamp | undefined;

  /**
   * @generated from field: int32 page_size = 7;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 8;
   */
  pageToken: string;
};

/**
 * Describes the message blobstore.v1.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema: GenMessage<SearchRequest> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 12);

/**
 * @generated from message blobstore.v1.SearchResponse
 */
export type SearchResponse = Message<"blobstore.v1.SearchResponse"> & {
  /**
   * @generated from field: repeated blobstore.v1.BlobMetadata blobs = 1;
   */
  blobs: BlobMetadata[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message blobstore.v1.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema: GenMessage<SearchResponse> = /*@__PURE__*/
  messageDesc(file_blobstore_v1_blobs, 13);

/**
 * BlobStoreService manages binary object storage.
 *
 * @generated from service blobstore.v1.BlobStoreService
 */
export const BlobStoreService: GenService<{
  /**
   * Upload stores a blob and returns its ID.
   *
   * @generated from rpc blobstore.v1.BlobStoreService.Upload
   */
  upload: {
    methodKind: "client_streaming";
    input: typeof UploadRequestSchema;
    output: typeof UploadResponseSchema;
  },
  /**
   * Download retrieves a blob by ID.
   *
   * @generated from rpc blobstore.v1.BlobStoreService.Download
   */
  download: {
    methodKind: "server_streaming";
    input: typeof DownloadRequestSchema;
    output: typeof DownloadResponseSchema;
  },
  /**
   * GetMetadata retrieves blob metadata without content.
   *
   * @generated from rpc blobstore.v1.BlobStoreService.GetMetadata
   */
  getMetadata: {
    methodKind: "unary";
    input: typeof GetMetadataRequestSchema;
    output: typeof GetMetadataResponseSchema;
  },
  /**
   * Delete removes a blob.
   *
   * @generated from rpc blobstore.v1.BlobStoreService.Delete
   */
  delete: {
    methodKind: "unary";
    input: typeof DeleteRequestSchema;
    output: typeof DeleteResponseSchema;
  },
  /**
   * List returns all blob IDs.
   *
   * @generated from rpc blobstore.v1.BlobStoreService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
  /**
   * Search finds blobs matching criteria.
   *
   * @generated from rpc blobstore.v1.BlobStoreService.Search
   */
  search: {
    methodKind: "unary";
    input: typeof SearchRequestSchema;
    output: typeof SearchResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_blobstore_v1_blobs, 0);

